module.exports = ['$q', function($q) {
  const utils = {}

  utils.copyProperties = function(oDest, oSource) {
    if (!oDest || !oSource) {
      return
    }

    for (const property in oSource) {
      oDest[property] = oSource[property]
    }
    return oDest
  }

  utils.loadScript = function (url) {
    const defer = $q.defer()

    const urlList = [].concat(url)
    const sucessRes = []
    for (let i = 0; i < urlList.length; i++) {
      const item = urlList[i]
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.onload = function () {
        console.log('脚本[' + item + ']引入成功！')
        sucessRes.push(item) === urlList.length && defer.resolve(sucessRes)
      }
      script.onerror = function () {
        console.log('脚本[' + item + ']引入失败！')
        defer.reject(sucessRes)
      }
      script.src = item
      document.getElementsByTagName('head')[0].appendChild(script)
    }

    return defer.promise
  }

  return utils
}]



// WEBPACK FOOTER //
// ./src/js/infrastructure/DomUtils.js